import { render, staticRenderFns } from "./FormResearch2.vue?vue&type=template&id=421fbd66&scoped=true&"
import script from "./FormResearch2.vue?vue&type=script&lang=js&"
export * from "./FormResearch2.vue?vue&type=script&lang=js&"
import style0 from "./FormResearch2.vue?vue&type=style&index=0&id=421fbd66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421fbd66",
  null
  
)

export default component.exports